import { render, staticRenderFns } from "./InputRequiredLocalize.vue?vue&type=template&id=28b9fc59&scoped=true"
import script from "./InputRequiredLocalize.vue?vue&type=script&lang=js"
export * from "./InputRequiredLocalize.vue?vue&type=script&lang=js"
import style0 from "./InputRequiredLocalize.vue?vue&type=style&index=0&id=28b9fc59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9fc59",
  null
  
)

export default component.exports